import { colorSettingDetection } from "../../utils/functions"

export interface ThemeDividerProps {
  currentTheme: string
}

export const ThemeDivider = ({ currentTheme }: ThemeDividerProps) => {
  const colorSetting = colorSettingDetection(currentTheme || "")
  const isDark = colorSetting.includes("dark")
  const borderColor = isDark ? "border-yellow-m10" : "border-gray-m9"
  return (
    <div className={`w-full h-full ${colorSetting}`}>
      <div className="w-full px-5 lg:px-20 m-auto max-w-[1440px]">
        <div className="flex items-center justify-center">
          <div className="flex items-center gap-[10px] justify-start">
            <div
              className={`w-[10px] h-[10px] rounded-full border-[1.5px] border-solid ${borderColor}`}
            ></div>
          </div>
          <div
            className={`w-full h-0 border border-dashed ${borderColor}`}
          ></div>
          <div className="flex items-center gap-[10px] justify-end">
            <div
              className={`w-[10px] h-[10px] rounded-full border-[1.5px] border-solid ${borderColor}`}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThemeDivider
